export const CourseFilters  = {
  TEMPLATE : 'course_template',
  CATEGORY : 'category',
  REGION: 'region',
  COURSETYPE: 'course_type'
} as const;
